// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-container {
    max-width: min(1400px, 50dvw);
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 10px;
    padding: 20px 20px;
    align-items: center;
    justify-content: space-between;
}

.model-list-container {
    height: min(800px, 100dvh);
    background: #ffffff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -35%);
    right: 0;
    z-index: 200;
    width: 400px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
}

.grid-item {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 0;
    margin-bottom: 180px;
    text-align: center;
    width: 100px;
    height: 100px;
    background-color: white;
    cursor: pointer;
}

@media (max-width: 1900px) {
    .grid-container {
        grid-template-columns: repeat(4, 1fr);
        gap: 20px 220px;
    }
}

@media (max-width: 1900px) {
    .grid-container {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px 240px;
    }
}

@media (max-width: 1600px) {
    .grid-container {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px 240px;
    }
}

@media (max-width: 1000px) {
    .grid-container {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px 80px;
    }
}

.grid-item img {
    width: 100px;
    height: 100px;
    object-fit: cover;
}

.grid-item p {
    margin-top: 10px;
    font-size: small;
    height: 100px;
    overflow-y: scroll;
}

.grid-item p::-webkit-scrollbar {
    display: none;
}

.grid-item p {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.thumbnail {
    width: 120px;
    height: 120px;
    object-fit: cover;
    margin-bottom: 10px;
}

.tag-search {
    display: flex;
    flex-direction: row;
    margin-bottom: 30px;
    width: max(350px, 48dvw);
}

.tag-search button {
    height: 40px;
    width: 120px;
    margin: 0;
}

.tag-search input {
    height: 40px;
    margin: 0 5px 0 0;
}

.logo-and-grid-container {
    overflow-y: auto;
    scrollbar-width: none;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
}

.logo {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 20px;
    position: relative;
    left: -18dvw;
}

.logo span {
    color: black;
}

.logo img {
    width: 60px;
    height: 60px;
}

.embryo-image {
    position: absolute;
    left: 0;
    bottom: 0;
    max-width: 19%;
    height: auto;
    top: 50%;
    transform: translateY(-50%);
    min-width: 150px;
    z-index: -1;
    opacity: 0.8;
}

.footer {
    position: relative;
    left: 50%;
    transform: translate(-50%, -100%);
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    padding-top: 20px;
    padding-bottom: 0;
    width: 100%;
}

.footer-image {
    width: min(1200px, 95dvw);
    height: auto;
    object-fit: cover;
    position: relative;
}

.footer-text {
    position: absolute;
    left: 11%;
    top: 46%;
    transform: translateX(-10%);
    color: white;
    font-size: 17px;
    font-family: "Calibri", Arial, sans-serif;
    text-align: left;
    max-width: 100%;
}

.footer-text a {
    color: #f0f0f0;
    text-decoration: none;
}

.footer-text a:hover {
    text-decoration: underline;
}

#root {
    min-height: 100dvh;
}

@media (max-width: 1150px) {
    .footer-text {
        font-size: 16px;
    }
}

@media (max-width: 1100px) {
    .footer-text {
        font-size: 15px;
    }
}

@media (max-width: 1000px) {
    .footer-text {
        font-size: 14px;
    }
}

@media (max-width: 920px) {
    .footer-text {
        font-size: 13px;
    }
}

@media (max-width: 850px) {
    .footer-text {
        font-size: 12px;
    }
}

@media (max-width: 750px) {
    .footer-text {
        font-size: 10px;
    }
}

.grid-and-search-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI;QACI,qCAAqC;QACrC,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,cAAc;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,cAAc;IACd,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iCAAiC;IACjC,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb","sourcesContent":[".grid-container {\n    max-width: min(1400px, 50dvw);\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 10px;\n    padding: 20px 20px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.model-list-container {\n    height: min(800px, 100dvh);\n    background: #ffffff;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -35%);\n    right: 0;\n    z-index: 200;\n    width: 400px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n}\n\n.grid-item {\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    padding: 0;\n    margin-bottom: 180px;\n    text-align: center;\n    width: 100px;\n    height: 100px;\n    background-color: white;\n    cursor: pointer;\n}\n\n@media (max-width: 1900px) {\n    .grid-container {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 20px 220px;\n    }\n}\n\n@media (max-width: 1900px) {\n    .grid-container {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 20px 240px;\n    }\n}\n\n@media (max-width: 1600px) {\n    .grid-container {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 20px 240px;\n    }\n}\n\n@media (max-width: 1000px) {\n    .grid-container {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 20px 80px;\n    }\n}\n\n.grid-item img {\n    width: 100px;\n    height: 100px;\n    object-fit: cover;\n}\n\n.grid-item p {\n    margin-top: 10px;\n    font-size: small;\n    height: 100px;\n    overflow-y: scroll;\n}\n\n.grid-item p::-webkit-scrollbar {\n    display: none;\n}\n\n.grid-item p {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n}\n\n.thumbnail {\n    width: 120px;\n    height: 120px;\n    object-fit: cover;\n    margin-bottom: 10px;\n}\n\n.tag-search {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 30px;\n    width: max(350px, 48dvw);\n}\n\n.tag-search button {\n    height: 40px;\n    width: 120px;\n    margin: 0;\n}\n\n.tag-search input {\n    height: 40px;\n    margin: 0 5px 0 0;\n}\n\n.logo-and-grid-container {\n    overflow-y: auto;\n    scrollbar-width: none;\n    max-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n}\n\n.logo {\n    font-size: 36px;\n    font-weight: bold;\n    margin-bottom: 20px;\n    position: relative;\n    left: -18dvw;\n}\n\n.logo span {\n    color: black;\n}\n\n.logo img {\n    width: 60px;\n    height: 60px;\n}\n\n.embryo-image {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    max-width: 19%;\n    height: auto;\n    top: 50%;\n    transform: translateY(-50%);\n    min-width: 150px;\n    z-index: -1;\n    opacity: 0.8;\n}\n\n.footer {\n    position: relative;\n    left: 50%;\n    transform: translate(-50%, -100%);\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f8f8f8;\n    padding-top: 20px;\n    padding-bottom: 0;\n    width: 100%;\n}\n\n.footer-image {\n    width: min(1200px, 95dvw);\n    height: auto;\n    object-fit: cover;\n    position: relative;\n}\n\n.footer-text {\n    position: absolute;\n    left: 11%;\n    top: 46%;\n    transform: translateX(-10%);\n    color: white;\n    font-size: 17px;\n    font-family: \"Calibri\", Arial, sans-serif;\n    text-align: left;\n    max-width: 100%;\n}\n\n.footer-text a {\n    color: #f0f0f0;\n    text-decoration: none;\n}\n\n.footer-text a:hover {\n    text-decoration: underline;\n}\n\n#root {\n    min-height: 100dvh;\n}\n\n@media (max-width: 1150px) {\n    .footer-text {\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 1100px) {\n    .footer-text {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 1000px) {\n    .footer-text {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 920px) {\n    .footer-text {\n        font-size: 13px;\n    }\n}\n\n@media (max-width: 850px) {\n    .footer-text {\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 750px) {\n    .footer-text {\n        font-size: 10px;\n    }\n}\n\n.grid-and-search-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
